import React from 'react';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';
import { any, objectOf } from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';
import TruckIcon from './markers';

const media = {
  tablet: '@media(min-width: 768px)',
  desktop: '@media(min-width: 1366px)',
};

const MapWrap = styled.div`
  display: none;

  ${media.tablet} {
    display: flex;

    .leaflet-container {
      height: 100vh;
      width: 100%;
    }

    .leaflet-container .leaflet-marker-icon {
      margin-left: -12px !important;
      margin-top: -40px !important;
    }
  }
`;

const TruckersMap = ({ truckerSelected }) => {
  const defaultPosition = [-34.603722, -58.381592];

  return (
    <MapWrap>
      <Map
        center={
          truckerSelected && truckerSelected.geoCode
            ? truckerSelected.geoCode.coordinates
            : defaultPosition
        }
        scrollWheelZoom={false}
        zoom={6}
      >
        <TileLayer
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {truckerSelected ? (
          <Marker
            icon={TruckIcon}
            position={
              truckerSelected.lastGeolocationReportGeolocation?.coordinates ||
              truckerSelected.geoCode?.coordinates ||
              defaultPosition
            }
          >
            <Popup>
              <b>Nombre: </b> {truckerSelected.name} <br />
              <b>CUIT: </b> {truckerSelected.cuit} <br />
              <b>Patente: </b> {truckerSelected.truck?.plate?.replace(/"/g, '').trim() || ''} <br />
              <b>Cel: </b> {truckerSelected.phoneNumber} <br />
              {truckerSelected.lastGeolocationReportGeolocation ? (
                <>
                  <b>Geolocalización reportada</b>
                  <br />
                  {moment(truckerSelected.lastGeolocationReportTimestamp).format('DD-MMM-YYYY')}
                  <br />
                  {moment(truckerSelected.lastGeolocationReportTimestamp).format('HH:mm')}
                  hs.
                </>
              ) : (
                <>
                  <b>No reporta geolocalización</b>
                  <br />
                  {truckerSelected.geoCode && <>(ciudad origen)</>}
                </>
              )}
            </Popup>
          </Marker>
        ) : (
          ''
        )}
      </Map>
    </MapWrap>
  );
};

TruckersMap.propTypes = {
  truckerSelected: objectOf(any),
};

TruckersMap.defaultProps = {
  truckerSelected: {},
};

export default TruckersMap;
